import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '../../../shared/components/ui/Button';
import FormInput from '../../../shared/components/ui/FormInput';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { createClosedDeal } from '../../services/api/implementation/impl';
import toast from 'react-hot-toast';
import Modal from '../../../shared/components/ui/Modal';
import { SelectLead } from './SelectLead';
import { CloseDeal } from './CloseDeal';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

// Dummy data for statuses

// Validation schema
const validationSchema = yup.object().shape({
  status: yup.string().required('Status is required')
});

export const UpdateStatus = ({
  onClose,
  onSubmit,
  statuses,
  type,
  isSubmitting,
  unitData,
  projectName,
  projectId
}) => {
  const navigate = useNavigate();
  const userId = Cookies.get('userId');
  const [isSelectLeadModalOpen, setIsSelectLeadModalOpen] = useState(false);
  const [isCloseDealModalOpen, setIsCloseDealModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      status: ''
    }
  });

  const selectedStatus = watch('status');

  // Watch for status changes and open lead selection modal if "Booked" is selected

  // Track page view
  useEffect(() => {
    mixpanel.track('Update Status Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (selectedStatus === 'Booked') {
      setIsSelectLeadModalOpen(true);
    }
  }, [selectedStatus]);

  // Mutation for creating closed deal
  const { mutate: createClosedDealMutation } = useMutation({
    mutationFn: (data) => createClosedDeal(data),
    onSuccess: () => {
      toast.success('Deal closed successfully');
      setIsCloseDealModalOpen(false);
      // Update the unit status to Booked
      onSubmit({ status: 'Booked' });
      onClose();
      if (selectedLead?.id) {
        navigate(`/builder/deals/${selectedLead.id}`, { state: { status: 'Closed Won' } });
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to close deal');
    }
  });

  const onSubmitForm = (data) => {
    if (data.status !== 'Booked') {
      onSubmit(data);
      onClose();
      reset();
    }
  };

  const handleLeadSelect = (lead) => {
    setSelectedLead(lead);
    setIsSelectLeadModalOpen(false);
    setIsCloseDealModalOpen(true);
  };

  const handleCloseDeal = (data) => {
    createClosedDealMutation(data);
  };

  console.log({ statuses });

  return (
    <>
      {/* <div className="flex flex-col justify-between items-start gap-4">
        <span className="text-lg border-b-[1px] border-stone-200 w-full pb-2">Update Status</span>
      </div> */}
      <form onSubmit={handleSubmit(onSubmitForm)} className="flex flex-col gap-4 pt-6">
        <div className="flex justify-between items-center w-full">
          {type === 'unitPricing' ? (
            <FormInput
              width={100}
              label={'Status'}
              register={register}
              register_key={'status'}
              type={'dropdown'}
              defaultValuePre={''}
              options={[
                { value: '', label: 'Select Status', disabled: true },
                ...(Array.isArray(statuses)
                  ? statuses.map((item) => ({
                      value: item?.trim(),
                      label: item?.replace(/_/g, ' ')?.trim() // Replace underscores with spaces for display
                    }))
                  : [])
              ]}
              errors={errors.status}
            />
          ) : (
            <FormInput
              width={100}
              label={'Status'}
              register={register}
              register_key={'status'}
              type={'dropdown'}
              defaultValuePre={''}
              options={[
                { value: '', label: 'Select Status', disabled: true },
                ...(Array.isArray(statuses)
                  ? statuses.map((item) => ({
                      value: item?.name?.trim(),
                      label: item?.name?.replace(/_/g, ' ')?.trim() // Replace underscores with spaces for display
                    }))
                  : [])
              ]}
              errors={errors.status}
            />
          )}
        </div>
        <div className="w-full flex justify-end items-center space-x-4 mt-8">
          <Button type="button" onClick={onClose} displayType="secondary">
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting || selectedStatus === 'Booked'}>
            Save
          </Button>
        </div>
      </form>

      {/* Select Lead Modal */}
      {isSelectLeadModalOpen && (
        <Modal
          width={50}
          name="Select Lead"
          onClose={() => {
            setIsSelectLeadModalOpen(false);
            reset({ status: '' }); // Reset the status when closing the modal
          }}>
          <SelectLead
            onClose={() => {
              setIsSelectLeadModalOpen(false);
              reset({ status: '' }); // Reset the status when closing the modal
            }}
            onLeadSelect={handleLeadSelect}
            isSubmitting={isSubmitting}
            projectName={projectName}
            projectId={projectId}
          />
        </Modal>
      )}

      {/* Close Deal Modal */}
      {isCloseDealModalOpen && (
        <Modal width={50} name="Close Deal" onClose={() => setIsCloseDealModalOpen(false)}>
          <CloseDeal
            onClose={() => setIsCloseDealModalOpen(false)}
            onSubmit={handleCloseDeal}
            isSubmitting={isSubmitting}
            unitData={unitData}
            selectedLead={selectedLead}
          />
        </Modal>
      )}
    </>
  );
};
